/*!
 * BUTAIMART ギフトカード保有者向けバナー
 * - localStorage に butaimart_gift_code がある人だけに表示
 * - チェックアウトでの貼り付けを補助するためコードをコピーできる
 * - セッション中に閉じたら再表示しない
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (sessionStorage.getItem('butaimart_gift_banner_dismissed')) return;

  var code = null;
  var balance = null;
  try {
    code = localStorage.getItem('butaimart_gift_code');
    balance = localStorage.getItem('butaimart_gift_balance');
  } catch (e) { return; }
  if (!code) return;

  // バナーが二重に挿入されないようにガード
  if (document.getElementById('butaimart-gift-banner')) return;

  // チェックアウトページではバナー非表示（ペースト先と被るので邪魔）
  if (/\/checkouts?\//.test(window.location.pathname)) return;

  var injectStyle = function () {
    if (document.getElementById('butaimart-gift-banner-style')) return;
    var s = document.createElement('style');
    s.id = 'butaimart-gift-banner-style';
    s.textContent =
      '#butaimart-gift-banner{position:fixed;left:0;right:0;bottom:0;z-index:9998;background:#2c4a3a;color:#fff;font-family:"Yu Gothic","Hiragino Sans",sans-serif;box-shadow:0 -4px 16px rgba(0,0,0,0.15);}' +
      '#butaimart-gift-banner .bgb-inner{max-width:960px;margin:0 auto;padding:12px 16px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:center;font-size:14px;line-height:1.4;}' +
      '#butaimart-gift-banner .bgb-label{font-weight:700;}' +
      '#butaimart-gift-banner .bgb-balance{color:#d4a843;font-weight:700;font-size:16px;font-family:"Inter","Helvetica Neue",sans-serif;}' +
      '#butaimart-gift-banner .bgb-balance-note{opacity:0.75;font-size:11px;margin-left:-4px;}' +
      '#butaimart-gift-banner .bgb-code{background:rgba(255,255,255,0.18);padding:4px 10px;border-radius:4px;font-family:"Inter","Helvetica Neue",monospace;letter-spacing:1px;font-size:13px;}' +
      '#butaimart-gift-banner .bgb-btn{background:#d4a843;color:#2c2c2c;border:none;padding:8px 14px;border-radius:6px;font-weight:700;font-size:13px;cursor:pointer;font-family:inherit;}' +
      '#butaimart-gift-banner .bgb-btn:hover{filter:brightness(1.05);}' +
      '#butaimart-gift-banner .bgb-btn.is-copied{background:#06C755;color:#fff;}' +
      '#butaimart-gift-banner .bgb-close{background:transparent;border:1px solid rgba(255,255,255,0.4);color:#fff;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:14px;display:inline-flex;align-items:center;justify-content:center;}' +
      '#butaimart-gift-banner .bgb-note{font-size:12px;opacity:0.85;display:block;width:100%;text-align:center;margin-top:2px;}' +
      '@media (max-width:640px){#butaimart-gift-banner .bgb-inner{padding:10px 12px;font-size:13px;gap:8px;}#butaimart-gift-banner .bgb-code{font-size:12px;}#butaimart-gift-banner .bgb-btn{padding:6px 10px;font-size:12px;}}';
    document.head.appendChild(s);
  };

  var renderBanner = function () {
    injectStyle();

    var wrap = document.createElement('div');
    wrap.id = 'butaimart-gift-banner';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', 'ギフトカード保有中の案内');

    var inner = document.createElement('div');
    inner.className = 'bgb-inner';

    var label = document.createElement('span');
    label.className = 'bgb-label';
    label.textContent = '🎁 ギフトカード残高';

    if (balance) {
      var balanceEl = document.createElement('span');
      balanceEl.className = 'bgb-balance';
      balanceEl.textContent = balance;
      label.appendChild(document.createTextNode(' '));
      label.appendChild(balanceEl);

      var balanceNote = document.createElement('span');
      balanceNote.className = 'bgb-balance-note';
      balanceNote.textContent = '（初期額面）';
      label.appendChild(balanceNote);
    }

    var codeEl = document.createElement('span');
    codeEl.className = 'bgb-code';
    codeEl.textContent = code;

    var copyBtn = document.createElement('button');
    copyBtn.className = 'bgb-btn';
    copyBtn.type = 'button';
    copyBtn.textContent = 'コードをコピー';
    copyBtn.addEventListener('click', function () {
      var done = function () {
        copyBtn.textContent = '✓ コピー済み';
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = 'コードをコピー';
          copyBtn.classList.remove('is-copied');
        }, 2500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        // フォールバック：execCommand
        var tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(tmp);
        done();
      }
    });

    var closeBtn = document.createElement('button');
    closeBtn.className = 'bgb-close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.textContent = '✕';
    closeBtn.addEventListener('click', function () {
      wrap.remove();
      try { sessionStorage.setItem('butaimart_gift_banner_dismissed', '1'); } catch (e) {}
    });

    var note = document.createElement('span');
    note.className = 'bgb-note';
    note.textContent = 'チェックアウト画面の「ギフトカード」欄にコードを貼り付けると残高が差し引かれます';

    inner.appendChild(label);
    inner.appendChild(codeEl);
    inner.appendChild(copyBtn);
    inner.appendChild(closeBtn);
    inner.appendChild(note);
    wrap.appendChild(inner);

    (document.body || document.documentElement).appendChild(wrap);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBanner);
  } else {
    renderBanner();
  }
})();
